<div class="flex flex_column">
    <div class="hq-rest-due-header flex-center">
        <img [src]="images?.HQ_REST_DUE_HEADER_IMG" alt="pending bills" />
        <img (click)="dismissModal()" [src]="images?.MODAL_CLOSE" alt="modal close" class="modal-close c-pointer" />
    </div>
    <div class="flex flex_column p-20 gap-4">
        <div class="total-due flex flex_sb">
            <div class="flex-2">
                <div class="fs-20">{{ 'HQ_ALL_DUE.DUE_OF_ALL_RESTAURANT' | fallbackTranslate }}</div>
                <div class="fs-36 fw-700">{{ currency }} {{ negativeCurrentBalance?.totalNegativeBalance_text }}</div>
                <div class="fs-14">{{ 'HQ_ALL_DUE.AMOUNT_TO_BE_PAID' | fallbackTranslate }}</div>
            </div>
            <div class="flex flex_column flex_sb gap-4 flex-1">
                <!-- Button to pay all together -->
                <button class="pay-btn pay-btn--primary flex-center fs-14 fw-600"
                    (click)="redirectToPaymentPage({ payAll : true})">{{ 'HQ_ALL_DUE.PAY_ALL_TOGETHER' | fallbackTranslate }}</button>
                <!-- Button to download all in one report -->
                <div class="flex gap-2 align-items-center c-pointer" (click)="downloadNegativeCurrentBalanceReport()">
                    <img [src]="images?.CLOUD_DOWNLOAD" alt="star icon" />
                    <div class="fs-14 fw-600">{{ 'HQ_ALL_DUE.ALL_IN_ONE_REPORT' | fallbackTranslate }}</div>
                </div>
            </div>
        </div>
        <div class="rest-due-container flex flex_column gap-4">
            <ng-container *ngFor="let data of negativeCurrentBalance.restaurants">
                <div class="rest-due flex flex_sb" [ngClass]="{ 'rest-due--selected': checked[data?.restaurantId] }">
                    <div class="flex gap-3 flex-2">
                        <!-- Checkbox to select restaurant for payment -->
                        <label nz-checkbox [(ngModel)]="checked[data?.restaurantId]"
                            (ngModelChange)="calculateTotalDue()"></label>
                        <div>
                            <div class="fs-16">{{ data?.restaurantName }}</div>
                            <div class="fs-24 fw-700">{{ currency }} {{ data?.balance_text }}</div>
                            <div class="fs-14">{{ 'HQ_ALL_DUE.AMOUNT_TO_BE_PAID' | fallbackTranslate }}</div>
                        </div>
                    </div>
                    <div class="flex flex_column flex_sb gap-4 flex-1">
                        <!-- Button to pay now for individual restaurant -->
                        <div class="pay-btn pay-btn--secondary flex-center fs-14 fw-600"
                            (click)="redirectToPaymentPage({ single : true , restaurantId: data?.restaurantId})">
                            {{ 'HQ_ALL_DUE.PAY_NOW' | fallbackTranslate }}
                        </div>
                        <!-- Button to download report for individual restaurant -->
                        <div class="flex gap-2 align-items-center c-pointer"
                            (click)="downloadNegativeCurrentBalanceReport(data?.restaurantId)">
                            <img [src]="images.CLOUD_DOWNLOAD" alt="star icon" />
                            <div class="fs-14 fw-600">{{ 'HQ_ALL_DUE.DOWNLOAD_REPORT' | fallbackTranslate }}</div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <!-- Section to display total amount payable -->
        <div *ngIf="totalDue.value > 0" class="flex flex_sb gap-5">
            <div class="flex flex_column flex-2">
                <!-- Description for total amount payable -->
                <div class="fs-14">{{ 'HQ_ALL_DUE.TOTAL_AMT_PAYABLE' | fallbackTranslate }}</div>
                <!-- Total amount payable -->
                <div class="fs-20 fw-700">{{ currency }} {{ totalDue.text }}</div>
            </div>
            <!-- Button to pay now for all selected restaurants -->
            <button class="pay-btn pay-btn--primary pay-btn--selected flex-center fs-16 fw-600 flex-3"
                (click)="redirectToPaymentPage({ multiple : true})">{{ 'HQ_ALL_DUE.PAY_NOW' | fallbackTranslate }}</button>
        </div>
    </div>
</div>